<label class="si-list-search">
  <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
  <input
    type="search"
    class="form-control"
    [value]="value"
    [placeholder]="'SALES_INSIGHTS_LIST_SEARCH' | translate"
    [attr.aria-label]="'SALES_INSIGHTS_LIST_SEARCH' | translate"
    (input)="onInput($any($event.target).value)"
  />
</label>
